import { render, staticRenderFns } from "./ShiftsInDialog.vue?vue&type=template&id=56df3808"
import script from "./ShiftsInDialog.vue?vue&type=script&lang=ts"
export * from "./ShiftsInDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports